module.exports = __webpack_public_path__ + "static/media/beep-03.ea0f5342.mp3";